import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { Button, Card } from 'sfy-react'
import OTPForm from '../../../common/components/OTPForm/OTPForm'
import { deleteFields, setFields } from '../../../redux/login'
import styles from '../Login.module.scss'
import { useCallback, useEffect } from 'react'
import { regex } from '../../../utils/form'

const Otp = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const translatedData = useSelector((state) => state.common.translatedData)
  const selectedCountryDetails = useSelector((state) => state.common.selectedCountryDetails)
  const fields = useSelector((state) => state.login.fields)

  useEffect(() => {
    dispatch(setFields({ otp: '' }))
    return () => {
      dispatch(deleteFields(['otp']))
    }
  }, [dispatch])

  const handleOnOTPChange = useCallback(
    (value) => {
      dispatch(setFields({ otp: value }))
    },
    [dispatch]
  )

  const handleOnChangeInput = () => {
    dispatch(deleteFields(['otp']))
    clearInterval(props.counterInterval)
    navigate(searchParams.get('redirect') ? `/login?redirect=${searchParams.get('redirect')}` : '/login')
  }

  const isContactSelected = !!(props.selectedContact?.mobileNo || props.selectedContact?.emailID)
  const field = isContactSelected
    ? !!props.selectedContact?.mobileNo
      ? `${selectedCountryDetails.phoneCode} - ${props.selectedContact?.mobileNo}`
      : props.selectedContact?.emailID
    : props.selectedAccount

  const isEmailLogin = regex['email'].test(field)
  return fields.consent ? (
    <Card className='mt20'>
      <div className={styles['form']}>
        <div className={styles['otp-title']}>{translatedData.login[isEmailLogin ? 'emailHeading' : 'mobileHeding']}</div>
        {translatedData.login['enterVerificationCode']}
        <div className={styles['change-input']}>
          <div>{field}</div>
          {!isContactSelected && (
            <Button classContent='d-block text-right' className='button button-link width-auto f14' handleOnClick={handleOnChangeInput}>
              <span>{translatedData.login.change}</span>
            </Button>
          )}
        </div>
        <OTPForm
          className={{
            inputContainer: styles['multi-input-size'],
          }}
          handleOnOTPChange={handleOnOTPChange}
          {...props}
          isEmailLogin={isEmailLogin}
        />
      </div>
    </Card>
  ) : (
    <Navigate to='/login' replace />
  )
}

export default Otp
